

export const frontMatter = {
	sidebar_position: 4,
	license: 'republish',
	author: 'Jan van Steenbergen',
	origin: 'http://steen.free.fr/interslavic/pronunciation.html'
};
export const contentTitle = 'Изговор';
export {default as metadata} from '@site/.docusaurus/docusaurus-plugin-content-docs/default/site-i-18-n-sr-cyrl-docusaurus-plugin-content-docs-current-learn-pronunciation-md-8d3.json'
export const assets = {

};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const toc = [{
  "value": "Преглед",
  "id": "overview",
  "level": 2
}, {
  "value": "Етимолошке екстензије алфабета",
  "id": "etymological-alphabet-extensions",
  "level": 2
}, {
  "value": "Стрес",
  "id": "stress",
  "level": 2
}, {
  "value": "Општа напомена",
  "id": "general-remark",
  "level": 2
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    em: "em",
    h1: "h1",
    h2: "h2",
    header: "header",
    li: "li",
    ol: "ol",
    p: "p",
    span: "span",
    strong: "strong",
    u: "u",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  }, {CustomAfterSection, CustomBeforeSection, IPA, MDPronunciation1, MDPronunciation2, TransliteratorElement} = _components;
  if (!CustomAfterSection) _missingMdxReference("CustomAfterSection", true);
  if (!CustomBeforeSection) _missingMdxReference("CustomBeforeSection", true);
  if (!IPA) _missingMdxReference("IPA", true);
  if (!MDPronunciation1) _missingMdxReference("MDPronunciation1", true);
  if (!MDPronunciation2) _missingMdxReference("MDPronunciation2", true);
  if (!TransliteratorElement) _missingMdxReference("TransliteratorElement", true);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.header, {
      children: _jsx(_components.h1, {
        id: "изговор",
        children: "Изговор"
      })
    }), "\n", _jsx(_components.h2, {
      id: "overview",
      children: "Преглед"
    }), "\n", _jsx(CustomBeforeSection, {}), "\n", _jsx(_components.p, {
      children: "Како се изговарају етнички језици одређују њихови изворни говорници. Ово важи и за међусловенски: иако то није ни етнички језик нити језик који служи као стандардни језик за Словене, Словенима би требало да буде лак и једноставан за изговор. Сви национални изговори у међусловенском језику су подједнако исправни; као што су британски, амерички и аустралијски изговори подједнако правилни у енглеском, тако и руски изговор међусловенског никако није ни бољи ни лошији од српског или пољског. Као резултат тога, изговор већине звукова (фонема) је променљив, у зависности од националности говорника, а сваки изговор дат у даљем тексту је само приближан. Чињеница да је изговор прилично слободан, међутим, не значи да не може постојати „идеалан” изговор за сваки фонем."
    }), "\n", _jsx(_components.p, {
      children: "Сва слова се могу изговарати онако како се изговарају у било којој словенској азбуци / абцеди. У следећој табели, изузеци су дати у трећој колони:"
    }), "\n", _jsx(MDPronunciation1, {
      children: _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: ["као ", _jsx(_components.code, {
            children: "a"
          }), " у ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: ["f", _jsx(_components.strong, {
              children: "a"
            }), "ther"]
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["као ", _jsx(_components.code, {
            children: "b"
          }), " у ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: [_jsx(_components.strong, {
              children: "b"
            }), "ook"]
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["као ", _jsx(_components.code, {
            children: "ts"
          }), " у ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: ["bi", _jsx(_components.strong, {
              children: "ts"
            })]
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["као ", _jsx(_components.code, {
            children: "ch"
          }), " у ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: [_jsx(_components.strong, {
              children: "ch"
            }), "urch"]
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["као ", _jsx(_components.code, {
            children: "d"
          }), " у ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: [_jsx(_components.strong, {
              children: "d"
            }), "eer"]
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["као ", _jsx(_components.code, {
            children: "j"
          }), " у ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: [_jsx(_components.strong, {
              children: "J"
            }), "ohn"]
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["као ", _jsx(_components.code, {
            children: "e"
          }), " у ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: ["b", _jsx(_components.strong, {
              children: "e"
            }), "st"]
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["као ", _jsx(_components.code, {
            children: "ye"
          }), " у ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: [_jsx(_components.strong, {
              children: "ye"
            }), "t"]
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["као ", _jsx(_components.code, {
            children: "f"
          }), " у ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: [_jsx(_components.strong, {
              children: "f"
            }), "orest"]
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["као ", _jsx(_components.code, {
            children: "g"
          }), " у ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: [_jsx(_components.strong, {
              children: "g"
            }), "ood"]
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["као ", _jsx(_components.code, {
            children: "ch"
          }), " на шкотском ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: ["lo", _jsx(_components.strong, {
              children: "ch"
            })]
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["као ", _jsx(_components.code, {
            children: "ea"
          }), " у ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: ["b", _jsx(_components.strong, {
              children: "ea"
            }), "t"]
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["као ", _jsx(_components.code, {
            children: "y"
          }), " у ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: [_jsx(_components.strong, {
              children: "y"
            }), "ard"]
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["као ", _jsx(_components.code, {
            children: "k"
          }), " на енглеском, али без аспирације"]
        }), "\n", _jsxs(_components.li, {
          children: ["као ", _jsx(_components.code, {
            children: "l"
          }), " на енглеском"]
        }), "\n", _jsxs(_components.li, {
          children: ["као ", _jsx(_components.code, {
            children: "li"
          }), " у ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: ["mil", _jsx(_components.strong, {
              children: "li"
            }), "on"]
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["као ", _jsx(_components.code, {
            children: "m"
          }), " у ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: [_jsx(_components.strong, {
              children: "m"
            }), "op"]
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["као ", _jsx(_components.code, {
            children: "n"
          }), " у ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: [_jsx(_components.strong, {
              children: "n"
            }), "orth"]
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["као ", _jsx(_components.code, {
            children: "ny"
          }), " у ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: ["ca", _jsx(_components.strong, {
              children: "ny"
            }), "on"]
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["као ", _jsx(_components.code, {
            children: "o"
          }), " у ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: [_jsx(_components.strong, {
              children: "o"
            }), "r"]
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["као ", _jsx(_components.code, {
            children: "p"
          }), " на енглеском, али без аспирације"]
        }), "\n", _jsxs(_components.li, {
          children: ["ваљано ", _jsx(_components.code, {
            children: "r"
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["као ", _jsx(_components.code, {
            children: "s"
          }), " у ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: [_jsx(_components.strong, {
              children: "s"
            }), "pin"]
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["као ", _jsx(_components.code, {
            children: "sh"
          }), " у ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: [_jsx(_components.strong, {
              children: "sh"
            }), "op"]
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["као ", _jsx(_components.code, {
            children: "t"
          }), " на енглеском, али без аспирације"]
        }), "\n", _jsxs(_components.li, {
          children: ["као ", _jsx(_components.code, {
            children: "oo"
          }), " у ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: ["b", _jsx(_components.strong, {
              children: "oo"
            }), "k"]
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["као ", _jsx(_components.code, {
            children: "v"
          }), " у ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: ["a", _jsx(_components.strong, {
              children: "v"
            }), "oid"]
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["као ", _jsx(_components.code, {
            children: "i"
          }), " у ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: ["b", _jsx(_components.strong, {
              children: "i"
            }), "t"]
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["као ", _jsx(_components.code, {
            children: "z"
          }), " у ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: [_jsx(_components.strong, {
              children: "z"
            }), "oo"]
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["као ", _jsx(_components.code, {
            children: "si"
          }), " у ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: ["vi", _jsx(_components.strong, {
              children: "si"
            }), "on"]
          })]
        }), "\n"]
      })
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.strong, {
        children: "Напомене:"
      })
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["У изговору самогласника постоји тенденција да постоје неке варијације на скали отворено/затворено и напред/позади. Само ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "u"
          })
        }), " је увек ", _jsx(IPA, {
          children: "u"
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: ["Да бисте избегли нејасноће, треба избегавати акање (изговарање ненаглашених самогласника као ", _jsx(IPA, {
          children: "ɑ"
        }), " или ", _jsx(IPA, {
          children: "ə"
        }), " на руском)."]
      }), "\n", _jsxs(_components.li, {
        children: ["Осим ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "a"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "e"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "ě"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "i"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "o"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "u"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "y"
          })
        }), ", и слово ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "r"
          })
        }), " такође може бити самогласник. То је случај када се појављује иза сугласника, а не прати самогласник, што резултира такозваним ", _jsx(_components.em, {
          children: "слоговним р"
        }), ". ", _jsx(TransliteratorElement, {
          children: "trg"
        }), " ", _jsx(IPA, {
          children: "tərg"
        }), ", ", _jsx(TransliteratorElement, {
          children: "cukr"
        }), " ", _jsx(IPA, {
          children: "ʦukər"
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: ["Када ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "ě"
          })
        }), " следи зубни/алвеоларни сугласник (", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "t"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "d"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "s"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "z"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "n"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "l"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "r"
          })
        }), "), овај сугласник се изговара меко (погледајте ", _jsx(_components.a, {
          href: "/sr-Cyrl/learn/phonology#hard-and-soft-consonants",
          children: "фонологију"
        }), "). После других сугласника производи исти звук као ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "e"
          })
        }), ", али испред ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "j"
          })
        }), ": ", _jsx(TransliteratorElement, {
          children: "dělo"
        }), " звучи као ", _jsx(_components.span, {
          className: "notranslate",
          translate: "no",
          children: "ďelo"
        }), ", ", _jsx(TransliteratorElement, {
          children: "pěsok"
        }), "  као ", _jsx(_components.span, {
          className: "notranslate",
          translate: "no",
          children: "pjesok"
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: ["Када ", _jsx(_components.code, {
          children: "ě"
        }), " следи зубни (дентални) или надзубни (алвеоларни) сугласник (", _jsx(_components.code, {
          children: "t"
        }), " ", _jsx(_components.code, {
          children: "d"
        }), " ", _jsx(_components.code, {
          children: "s"
        }), " ", _jsx(_components.code, {
          children: "z"
        }), " ", _jsx(_components.code, {
          children: "n"
        }), " ", _jsx(_components.code, {
          children: "l"
        }), " ", _jsx(_components.code, {
          children: "r"
        }), "), тај сугласник се тада изговара меко (погледајте ", _jsx(_components.a, {
          href: "/sr-Cyrl/learn/phonology#hard-and-soft-consonants",
          children: "фонологију"
        }), "). После осталих сугласника производи исти звук као ", _jsx(_components.code, {
          children: "e"
        }), ", али уз ", _jsx(_components.code, {
          children: "j"
        }), " испред њега. На пример ", _jsx(TransliteratorElement, {
          children: "dělo"
        }), " звучи као ", _jsx(_components.span, {
          className: "notranslate",
          translate: "no",
          children: "ďelo"
        }), ", ", _jsx(TransliteratorElement, {
          children: "pěsok"
        }), "  као ", _jsx(_components.span, {
          className: "notranslate",
          translate: "no",
          children: "pjesok"
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: ["Сугласник испред ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "i"
          })
        }), " се такође може изговарати меко, али то није обавезно."]
      }), "\n", _jsxs(_components.li, {
        children: ["Исто тако, сугласник је инхерентно мекан и испред ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "j"
          })
        }), ", осим ако овај сугласник није део префикса: ", _jsx(TransliteratorElement, {
          children: "žitje"
        }), " се изговара ", _jsx(_components.span, {
          className: "notranslate",
          translate: "no",
          children: "žiťje"
        }), ", али у речи ", _jsx(TransliteratorElement, {
          children: "odjehati"
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "d"
          })
        }), " остаје тврд."]
      }), "\n", _jsxs(_components.li, {
        children: ["С друге стране, иако прасловенска фонема ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "e"
          })
        }), " омекшава претходни сугласник у пољском и руском језику, у овом случају боље је задржати тврд изговор."]
      }), "\n", _jsxs(_components.li, {
        children: ["Слово ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "l"
          })
        }), " је донекле посебан случај. Пре ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "a"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "o"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "u"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "y"
          })
        }), ",  као и на крају слога, звучи као „дебео” ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "l"
          })
        }), " у ", _jsx(_components.span, {
          className: "notranslate",
          translate: "no",
          lang: "en",
          children: "full"
        }), ". Пре ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "e"
          })
        }), ", ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "ě"
          })
        }), "  и ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "i"
          })
        }), " је прилично склон да прати образац изговора ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "lj"
          })
        }), ": ", _jsx(TransliteratorElement, {
          children: "lev"
        }), " ", _jsx(IPA, {
          children: "lʲɛv"
        }), "  ~ ", _jsx(IPA, {
          children: "ʎɛf"
        }), ", итд."]
      }), "\n", _jsxs(_components.li, {
        children: ["Не постоје строга правила за девоцирање звучних сугласника на крају речи, или изговарање незвучних сугласника испред звучних сугласника. Свако може да користи изговор који му највише одговара. Дакле, ", _jsx(TransliteratorElement, {
          children: "Bog"
        }), " ", _jsx(IPA, {
          children: "bɔk"
        }), "  и ", _jsx(TransliteratorElement, {
          children: "prosba"
        }), " ", _jsx(IPA, {
          children: "prɔzbɑ"
        }), "  су оба тачна. Међутим, генерално, заслужује препоруку да пратите изговор који је што је могуће ближи ономе како је написан."]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "etymological-alphabet-extensions",
      children: "Етимолошке екстензије алфабета"
    }), "\n", _jsxs(_components.p, {
      children: ["Осим стандардног алфабета датог горе, међусловенско латинично писмо такође има скуп необавезних знакова који у основи раде две ствари. Пре свега, они представљају фонеме које су еволуирале у различитим правцима у словенским језицима, а друго, директно се везују за њихово прасловенско порекло. На пример, самогласник ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "å"
        })
      }), " у ", _jsx(TransliteratorElement, {
        children: "kråva"
      }), " „крава” указује на то да ова реч потиче од прасловенског ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        lang: "sla",
        children: "korva"
      }), ", који је постао ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        lang: "pl",
        children: "krova"
      }), " у пољском и лужичком, ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        lang: "zle",
        children: "korova"
      }), " у источнословенском и ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: "krava"
      }), " у чешки, словачки и јужнословенски. Најекстремнији случај је несумњиво ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "đ"
        })
      }), " (од прасловенског ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "dj"
        })
      }), "), који је у разним језицима еволуирао у ", _jsx(IPA, {
        children: "d͡z"
      }), ", ", _jsx(IPA, {
        children: "z"
      }), ", ", _jsx(IPA, {
        children: "ʒ"
      }), ", ", _jsx(IPA, {
        children: "ʒd"
      }), ", ", _jsx(IPA, {
        children: "j"
      }), ",  итд."]
    }), "\n", _jsxs(_components.p, {
      children: ["Ови знакови припадају ", _jsx(_components.a, {
        href: "/sr-Cyrl/learn/orthography#etymological-alphabet",
        children: "етимолошком писму"
      }), ". Они се не користе у обичном писаном међусловенском, односно пишу се, али без дијакритичких знакова (осим ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "ć"
        })
      }), " и ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "đ"
        })
      }), ", који се пишу ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "č"
        })
      }), " и ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "dž"
        })
      }), " респективно), а наравно могу да се изговарају и као такве. Међутим, могуће је покушати и за „просечан” изговор који више одговара словенској већини. У случају горе поменутог ", _jsx(TransliteratorElement, {
        children: "kråva"
      }), ", на пример, то би значило звук негде између ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "a"
        })
      }), " и ", _jsx(TransliteratorElement, {
        children: _jsx(_components.code, {
          children: "o"
        })
      }), " (у IPA: ", _jsx(IPA, {
        children: "ɒ"
      }), ")."]
    }), "\n", _jsx(MDPronunciation2, {
      children: _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: ["као ", _jsx(_components.code, {
            children: "o"
          }), " у ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: ["m", _jsx(_components.strong, {
              children: "o"
            }), "ther"]
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["као ", _jsx(_components.code, {
            children: "ch"
          }), " у ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: [_jsx(_components.strong, {
              children: "ch"
            }), "eap"]
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["као ", _jsx(_components.code, {
            children: "d"
          }), " у ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: [_jsx(_components.strong, {
              children: "d"
            }), "uke"]
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["као ", _jsx(_components.code, {
            children: "j"
          }), " у ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: [_jsx(_components.strong, {
              children: "j"
            }), "eep"]
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["као ", _jsx(_components.code, {
            children: "e"
          }), " у ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: ["bett", _jsx(_components.strong, {
              children: "e"
            }), "r"]
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["као ", _jsx(_components.code, {
            children: "ya"
          }), " у ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: [_jsx(_components.strong, {
              children: "ya"
            }), "m"]
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["као ", _jsx(_components.code, {
            children: "lj"
          }), ", обично пре ", _jsx(_components.code, {
            children: "j"
          }), ", ", _jsx(_components.code, {
            children: "n"
          }), "  или ", _jsx(_components.code, {
            children: "s"
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["као ", _jsx(_components.code, {
            children: "nj"
          }), ", обично пре ", _jsx(_components.code, {
            children: "j"
          }), " или ", _jsx(_components.code, {
            children: "s"
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["као ", _jsx(_components.code, {
            children: "o"
          }), " у ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: ["mem", _jsx(_components.strong, {
              children: "o"
            }), "ry"]
          })]
        }), "\n", _jsx(_components.li, {
          children: "подигнута алвеоларна трила"
        }), "\n", _jsxs(_components.li, {
          children: ["као ", _jsx(_components.code, {
            children: "sh"
          }), " у ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: [_jsx(_components.strong, {
              children: "sh"
            }), "eet"]
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["као ", _jsx(_components.code, {
            children: "t"
          }), " у ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: [_jsx(_components.strong, {
              children: "t"
            }), "ube"]
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["између ", _jsx(_components.code, {
            children: "ow"
          }), " у америчким ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: ["m", _jsx(_components.strong, {
              children: "ow"
            })]
          }), " и ", _jsx(_components.code, {
            children: "ew"
          }), " у ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: ["h", _jsx(_components.strong, {
              children: "ew"
            })]
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["звучни еквивалент ", _jsx(_components.code, {
            children: "ś"
          })]
        }), "\n"]
      })
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.strong, {
        children: "Напомене:"
      })
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Овде је посебно занимљив лик ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "ę"
          })
        }), ". „Тврди” изговор ", _jsx(IPA, {
          children: "ɛ"
        }), " је карактеристичан за јужнословенски, али у осталим језицима његов изговор варира између ", _jsx(IPA, {
          children: "ja"
        }), ", ", _jsx(IPA, {
          children: "jɛ"
        }), "  и ", _jsx(IPA, {
          children: "jɔ̃"
        }), ". Пратећи правило већине, ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "e"
          })
        }), " би требало да се изговара као тврдо ", _jsx(IPA, {
          children: "ɛ"
        }), ", али ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "ę"
          })
        }), " више као ", _jsx(IPA, {
          children: "jæ"
        }), ". То значи да се ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "ę"
          })
        }), " понаша као ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "ě"
          })
        }), " а не ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "e"
          })
        }), ", а као ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "ě"
          })
        }), " може да ублажи претходни сугласник."]
      }), "\n", _jsxs(_components.li, {
        children: ["Упркос огонку, ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "ę"
          })
        }), " и ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "ų"
          })
        }), " се не изговарају као назални самогласници као у пољском!"]
      }), "\n", _jsxs(_components.li, {
        children: ["Меки сугласници ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "t́"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "d́"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "ś"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "ź"
          })
        }), " ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "ŕ"
          })
        }), "  (изговарају се тврди у јужнословенском, делимично и у чешком и словачком) остварују се или тако што након тврдог сугласника следи звук сличан ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "j"
          })
        }), ", или омекшавањем или палатализацијом."]
      }), "\n", _jsxs(_components.li, {
        children: ["Када слово ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "ŕ"
          })
        }), " делује као меки пандан слоговном ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "r"
          })
        }), ", оно може да ублажи претходни сугласник или да иза њега стоји ", _jsx(IPA, {
          children: "j"
        }), ": ", _jsx(TransliteratorElement, {
          children: "mŕtvy"
        }), " ", _jsx(IPA, {
          children: "mjǝrtvɪ"
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: ["Меки сугласници ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "ľ"
          })
        }), " и ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "ń"
          })
        }), " се користе за писање ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "lj"
          })
        }), " и ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "nj"
          })
        }), " пре ", _jsx(TransliteratorElement, {
          children: _jsx(_components.code, {
            children: "j"
          })
        }), ", што доводи до извесног продужења последњег, на пример ", _jsx(TransliteratorElement, {
          children: "dělańje"
        }), " ", _jsx(IPA, {
          children: "dʲɛɫanʲĭɛ"
        }), "."]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "stress",
      children: "Стрес"
    }), "\n", _jsx(_components.p, {
      children: "Акцентуација је бесплатна. Међутим, ако желите да останете на сигурној страни, заслужујете препоруку да следите као смернице:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "Када реч има два слога, нагласак пада на први слог."
      }), "\n", _jsx(_components.li, {
        children: "Када реч има три слога, нагласак пада на први или други слог."
      }), "\n", _jsx(_components.li, {
        children: "Када реч има четири слога, нагласак пада на други или трећи слог."
      }), "\n", _jsxs(_components.li, {
        children: ["На стрес не треба утицати прегиб; ако се придев ", _jsx(TransliteratorElement, {
          children: "běly"
        }), " изговара ", _jsxs(TransliteratorElement, {
          children: ["b", _jsx(_components.u, {
            children: "ě"
          }), "ly"]
        }), ", генитив треба да се изговара ", _jsxs(TransliteratorElement, {
          children: ["b", _jsx(_components.u, {
            children: "ě"
          }), "logo"]
        }), " а не ", _jsxs(TransliteratorElement, {
          children: ["běl", _jsx(_components.u, {
            children: "o"
          }), "go"]
        }), "."]
      }), "\n", _jsx(_components.li, {
        children: "Уопштено говорећи, боље је избегавати да нагласак пада на префиксе, суфиксе, падежне наставке итд."
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "general-remark",
      children: "Општа напомена"
    }), "\n", _jsx(_components.p, {
      children: "Када је реч о говору, увек треба имати на уму да слушалац вероватно није упознат са међусловенским, а чак и ако јесте, није навикао да га слуша. Кад год у разговору користите интерславски, увек се уверите да вас особа са којом разговарате заиста разуме. Говорите полако, одржавајте контакт очима, јасно артикулишите и увек будите добар слушалац. Уосталом, комуникација није само ствар језика, подједнако је важан и невербални део."
    }), "\n", _jsx(_components.p, {
      children: "Исто, можда чак и више, важи и када се обраћате публици. Интерславенски језик је конструисан да максимизира разумљивост, али то не значи да сваки Словен може да разуме сваку његову реч. Слушање интерславског је ствар сталног успостављања веза и конотација, и кад год неко чује реч коју не разуме — што је прилично неизбежно — постоји велика вероватноћа да ће почети да размишља о томе и да пропусти остатак ваше реченице. Неопходно је да својој публици дате све време које јој је потребно да обради ваше информације, да их пустите. Зато немојте говорити брзо, говорите јасно, дубоко удахните између реченица, користите прозодију што боље можете, и тако даље..."
    }), "\n", _jsx(CustomAfterSection, {})]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}

